import { createApp } from "vue";
import App from "@/App.vue";
import router from "./router";
import store from "./store/index";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import { vModalFocus } from "./utils/useModalFocus";
import { PDFPlugin } from "vue3-pdfmake";
import VueExcelEditor from "vue3-excel-editor";
//import "vue3-excel-editor/dist/style.css"; // ←コレ
// import "vue3-excel-editor/dist/vue3-excel-editor.css";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueAwesomePaginate);
app.use(PDFPlugin);
app.use(VueExcelEditor);
// app.directive('modal-focus', vModalFocus);

// v-modal-focusというディレクティブ名がVueアプリケーションに登録される。
// 使用
// v-modal-focusを任意のコンポーネント内のHTML要素に適用。

// DOMがマウントされると、mountedフックが実行される。
// DOMがアンマウントされると、unmountedフックが実行される。
// 制御

// キーボードイベント（Tab、Enterキーなど）やフォーカス制御が有効になる。
// 1. 関係性の解説
// ① app.directive
// app.directive はVueアプリケーションにカスタムディレクティブを登録する関数です。
// 第一引数にディレクティブ名、第二引数にディレクティブオブジェクトを指定します。

// app.directive('modal-focus', vModalFocus);
// modal-focus: テンプレートで使用する際のディレクティブ名（v-modal-focusとして使用）。
app.directive("modal-focus", vModalFocus);

//app.use(VueToast);

app.mount("#app");

export default function () {
  return useToast();
}
